<template>
  <div id="pager" class="fixed-bottom justify--center va-row">
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item">
          <button
            type="button"
            class="page-link"
            v-if="page != 1"
            @click="page--"
          >{{$t('general.previousPage')}}</button>
        </li>
        <li class="page-item">
          <button
            type="button"
            class="page-link"
            v-for="pageNumber in pages.slice(page-1, page+5)"
            @click="page = pageNumber"
            v-bind:key="pageNumber"
          >{{pageNumber}}</button>
        </li>
        <li class="page-item">
          <button
            type="button"
            @click="page++"
            v-if="page < pages.length"
            class="page-link"
          >{{$t('general.nextPage')}}</button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Pager",
  props: {
    pagedObjects: {
      type: Array,
      default: []
    },
    itemsPerPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      page: 1,
      // perPage: 20,
      pages: []
    };
  },
  computed: {
    displayedPosts() {
      return this.paginate(this.pagedObjects);
    }
  },
  watch: {
    pagedObjects() {
      this.setPages();
    },
    page() {
      const page = this.page;
      this.$emit("pageChanged", { page });
    }
  },
  methods: {
    setPages() {
      let numberOfPages = Math.ceil(
        this.pagedObjects.length / this.itemsPerPage
      );
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(pagedObjects) {
      let page = this.page;
      let perPage = this.itemsPerPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return pagedObjects.slice(from, to);
    }
  },
  filters: {
    trimWords(value) {
      return (
        value
          .split(" ")
          .splice(0, 20)
          .join(" ") + "..."
      );
    }
  }
};
</script>

<style lang="scss">
#pager {
  button.page-link {
    display: inline-block;
  }
  button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
  }
}
</style>
